import request, { uploadFile } from '@/utils/request'

/**
 * 素材分组列表（含未分组与各分组数量）
 * @returns {Promise<Array>} [{ id, name, sort, count }]
 */
export function getGroupList() {
  return request({
    url: 'attachment/group/list',
    method: 'get'
  })
}

/**
 * 新建或编辑分组
 * @param {{ id?: number, name: string }} data
 */
export function saveGroup(data) {
  return request({
    url: 'attachment/group/save',
    method: 'post',
    data
  })
}

/**
 * 删除分组（组内素材会移入未分组）
 * @param {number} id
 */
export function deleteGroup(id) {
  return request({
    url: `attachment/group/del/${id}`,
    method: 'delete'
  })
}

/**
 * 素材列表
 * @param {{ group_id?: number, keyword?: string, type?: number, page?: number, limit?: number }} params
 */
export function getAttachmentList(params) {
  return request({
    url: 'attachment/list',
    method: 'get',
    params
  })
}

/**
 * 上传素材
 * @param {{ file: File, groupId?: number, type?: number, onProgress?: Function }} options
 */
export function uploadAttachment({ file, groupId = 0, type, onProgress }) {
  return uploadFile({
    url: 'attachment/upload',
    file,
    data: { group_id: groupId, type },
    onProgress
  })
}

/**
 * 批量移动素材到指定分组
 * @param {number[]} ids
 * @param {number} groupId
 */
export function moveAttachments(ids, groupId) {
  return request({
    url: 'attachment/move',
    method: 'post',
    data: { ids, group_id: groupId }
  })
}

/**
 * 批量删除素材
 * @param {number[]} ids
 */
export function deleteAttachments(ids) {
  return request({
    url: 'attachment/del',
    method: 'post',
    data: { ids }
  })
}
